export enum SubmissionCommunicationStatus {
  submitted = "Submitted",
  accepted = "Accepted",
  rejected = "Rejected",
  notSubmitted = "Not Submitted",
}
